import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react';

import { SingleInput } from '../../Res/BaseInput';
import { ReqSalaryItem } from '../../../../item/ItemContractorAttendance_RecruitmentItem_SalaryBase';

export const ContractorAttendanceDailogSalaryAddAmount = forwardRef((props, ref) => {
    const [SalaryAddAmount, setSalaryAddAmount] = useState(0)
    const [SalaryAddItems, setSalaryAddItems] = useState([])

    useEffect(() => {
        if (props.obj !== undefined && props.obj !== SalaryAddItems) {
            setSalaryAddAmount(props.SalaryAddAmount)
            setSalaryAddItems(JSON.parse(props.obj))
        }
    }, [props.obj])

    // useEffect(() => {
    //     // console.log(props)
    //     console.log(SalaryAddAmount)
    // })

    function setSalaryAddItem(salaryAddItem) {
        var change = false
        var amounts = 0
        SalaryAddItems.forEach((item, index, arr) => {
            if (item.key === salaryAddItem.key) {
                arr[index] = salaryAddItem
                change = true
            }
            amounts += arr[index].amount
        });
        if (change) {
            // console.log(AbsenceItems)
            setSalaryAddItems(JSON.parse(JSON.stringify(SalaryAddItems)))
            setSalaryAddAmount(amounts)
        }
    }

    useImperativeHandle(ref, () => ({
        send: () => {
            props.action({ SalaryAddItems, SalaryAddAmount })
        }
    }));
    return (
        <table className="table table-striped table-bordered table-hover  dataTable">
            <thead>
                <tr role="row">
                    <th className="text-center sorting col-sm-4">項目名稱</th>
                    <th className="text-right sorting col-sm-4">金額</th>
                </tr>
                {
                    SalaryAddItems.map((salaryAddItem) => (
                        <DailogAbsenceAmoutItem key={salaryAddItem.key} salaryAddItem={salaryAddItem} action={setSalaryAddItem} />
                    ))
                }
                <tr role="row">
                    <td className="text-center">加項總金額</td>
                    <td className="text-right"><span className="text-success">{SalaryAddAmount}</span></td>
                </tr>
            </thead>
        </table>
    )
})

function DailogAbsenceAmoutItem({ salaryAddItem, action }) {
    const [mSalaryAddItem, setASsalaryAddItem] = useState({})
    const [name, setName] = useState("")
    const [amount, setAmount] = useState(0)

    const [init, setInit] = useState(true)

    useEffect(() => {
        console.log(salaryAddItem)
        if (salaryAddItem !== undefined && Object.keys(salaryAddItem).length !== 0 && salaryAddItem !== mSalaryAddItem) {

            var item = new ReqSalaryItem({})
            item.fromJson(salaryAddItem)

            setName(item.name)
            setAmount(item.amount)
            setASsalaryAddItem(item)
            // console.log(item)
        }
    }, [salaryAddItem])

    useEffect(() => {
        console.log(amount)
        if (init) {
            setInit(false)
        } else {
            var item = Combination(salaryAddItem)
            action(item)
        }
    }, [amount])

    function Combination(salaryAddItem) {
        var item = new ReqSalaryItem({})
        item.fromJson(salaryAddItem)
        setAmount(item.amount)
        setASsalaryAddItem(JSON.parse(JSON.stringify(item)))
        return item
    }

    function inputAmount(amount) {
        // console.log(amount)
        var item = new ReqSalaryItem({})
        item.fromJson(salaryAddItem)
        item.setAmount(amount)
        setAmount(item.amount)
        setASsalaryAddItem(JSON.parse(JSON.stringify(item)))
        action(item)
    }

    return (

        <tr role="row">
            <td className="text-center">{name}</td>
            <td className="text-right">
                <SingleInput val={amount} action={inputAmount} placeholder={176} size={12} type={"number"} isRight={true} />
            </td>
        </tr>
    )
}